import Flickity from 'flickity';
import { createPrevArrow, createNextArrow } from '../base/carousel';

export function init() {
	const elements = Array.from(document.querySelectorAll('.js-banner'));

	elements.forEach(element => {
		new Flickity(element.querySelector('.js-banner-carousel'), {
			wrapAround: true,
		});

		const ui = element.querySelector('.js-banner-ui');
		const nextButton = element.querySelector('.flickity-prev-next-button.next');
		const prevButton = element.querySelector('.flickity-prev-next-button.previous');

		nextButton.innerHTML = createNextArrow();
		prevButton.innerHTML = createPrevArrow();

		ui.append(prevButton, nextButton);
	});
}
